<template>
    <div
        v-if="show_confirm"
        class="p-6 text-center"
    >
        <base-svg
            name="illustration-envelope-tick"
            class="w-full mx-auto mb-6 max-w-2xs"
        />

        <h6 class="mb-3 text-lg font-normal font-semibold">
            You've got mail!
        </h6>

        <p class="text-grey-darker">
            Your account has been successfully registered. To activate it, please confirm your email address
            by clicking on the link we’ve just sent you.
        </p>
    </div>

    <users-store
        v-else
        :sid="sid"
        v-slot="{
            error,
            is_loading,
            has_loaded,
            store
        }"
        @success="onSuccess"
    >
        <users-create-form
            :sid="sid"
            :is-saving="is_loading || has_loaded"
            @submit="store(_.extend(arguments[0], { intended }))"
            :is-tenant="true"
        >
            <template v-slot:modals>
                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </template>
        </users-create-form>
    </users-store>
</template>

<script>
    import _ from 'lodash'
    import PreloadedMixin from '../../../mixins/preloaded'
    import UsersCreateForm from '../../../components/users-create-form'
    import UsersStore from '../../../components/users-store'

    export default {
        mixins: [
            PreloadedMixin
        ],
        components: {
            UsersCreateForm,
            UsersStore
        },
        data () {
            return {
                sid: _.uuid(),
                show_confirm: false
            }
        },
        computed: {
            intended () {
                return this.$laroute.route('residencies.accept.store', {
                    token: this.$route.params.token
                })
            }
        },
        created () {
            const url = this.$laroute.route('applications.sessions.create', {
                application: this.$route.params.application
            })

            this.$validator.messages({
                'email.unique': this.$t('validation.unique', {
                    attribute: 'email'
                }) + ` <a href="${url}" class="text-inherit">Login instead?</a>`
            }, this.sid)
        },
        methods: {
            onSuccess ({ data: user }) {
                this.$track(
                    'auth.users.create',
                    'form-submission',
                    'A guest has created an account'
                )

                setTimeout(() => {
                    if (user.has_verified_email) {
                        window.location = this.intended
                    } else {
                        this.show_confirm = true
                    }
                }, 0)
            }
        }
    }
</script>
